/* eslint-disable
max-len,
no-mixed-spaces-and-tabs,
react/jsx-indent,
react/jsx-first-prop-new-line,
*/

import React, { PureComponent, PropTypes } from 'react';
import cn from 'classnames';

import styles from './styles.scss';

export class ClockinCycle extends PureComponent {
  render() {
    return (
      <div className={this.props.className}>
        <svg version="1.1"
          id="Illust"
          xmlns="http://www.w3.org/2000/svg"
          x="0px"
          y="0px"
          viewBox="0 0 646.5 462"
        >
        <g>
          <g>
            <g>
              <g>
                <g>
                  <path className={styles.st0}
                    d="M79.5,389.5c1.9-0.6,3.8,0.2,4.5,2c0.6,1.7-0.3,3.7-2.1,4.4c-1.8,0.7-3.9-0.2-4.6-1.9C76.6,392.1,77.6,390.1,79.5,389.5z"
                  />
                  <path className={styles.st0}
                    d="M71.7,363.2c1.9-0.4,3.8,0.7,4.3,2.4c0.5,1.8-0.7,3.6-2.6,4.1c-1.9,0.5-3.8-0.6-4.3-2.4C68.6,365.5,69.8,363.7,71.7,363.2z"
                  />

                  <ellipse transform="matrix(0.9569 -0.2905 0.2905 0.9569 -106.8101 38.4261)" className={styles.st0} cx="76" cy="378.9" rx="1.8" ry="1.7" />
                  <path className={styles.st0}
                    d="M89.9,414.8c1.8-0.8,3.9-0.2,4.7,1.5c0.8,1.7,0,3.7-1.7,4.6c-1.8,0.9-3.9,0.2-4.7-1.5C87.4,417.7,88.1,415.6,89.9,414.8z"
                  />
                  <path className={styles.st0} d="M83.6,405.4c-0.4-0.9,0.1-1.9,1-2.3s2,0,2.4,0.9c0.4,0.9-0.1,1.9-1,2.3C85.1,406.6,84,406.2,83.6,405.4z" />
                  <path className={styles.st0} d="M67.6,352.5c-0.2-1,0.5-1.9,1.5-2s1.9,0.4,2.1,1.4c0.2,0.9-0.5,1.9-1.5,2S67.8,353.5,67.6,352.5z" />
                  <path className={styles.st0}
                    d="M103,439c1.7-1,3.8-0.6,4.8,1c1,1.6,0.4,3.7-1.2,4.8c-1.6,1.1-3.8,0.6-4.8-1C100.8,442.1,101.3,440,103,439z"
                  />
                  <path className={styles.st0}
                    d="M90,414.9c1.8-0.8,3.9-0.2,4.7,1.5c0.8,1.7,0,3.7-1.7,4.6c-1.8,0.9-3.9,0.2-4.7-1.5C87.4,417.8,88.2,415.8,90,414.9z"
                  />
                  <path className={styles.st0}
                    d="M95.8,430.3c-0.5-0.8-0.1-1.9,0.8-2.4c0.9-0.5,2-0.2,2.4,0.6c0.5,0.8,0.2,1.9-0.7,2.4S96.3,431.1,95.8,430.3z"
                  />
                  <path className={styles.st0}
                    d="M110.5,453.6c-0.5-0.8-0.3-1.9,0.5-2.5c0.8-0.6,1.9-0.4,2.5,0.4c0.5,0.8,0.3,1.9-0.5,2.5C112.1,454.6,111,454.4,110.5,453.6z"
                  />
                </g>
              </g>
              <g>
                <g>
                  <path className={styles.st0}
                    d="M66.1,277.9c2,0.2,3.4,1.8,3.3,3.7c-0.1,1.8-1.8,3.2-3.8,3.1s-3.4-1.8-3.3-3.7C62.4,279.1,64.1,277.7,66.1,277.9z"
                  />
                  <path className={styles.st0}
                    d="M70.2,250.8c1.9,0.4,3.2,2.2,2.9,4c-0.3,1.8-2.2,3-4.1,2.7c-1.9-0.3-3.2-2.1-2.9-4C66.4,251.6,68.2,250.4,70.2,250.8z"
                  />
                  <path className={styles.st0} d="M65.6,266.6c0.1-1,1-1.6,2-1.5c1,0.1,1.7,1,1.6,2c-0.1,0.9-1,1.6-2,1.5S65.5,267.5,65.6,266.6z" />
                  <path className={styles.st0}
                    d="M64.8,305.2c2,0,3.6,1.5,3.6,3.3c0,1.8-1.5,3.4-3.5,3.5c-2,0.1-3.6-1.4-3.6-3.3C61.3,306.8,62.9,305.3,64.8,305.2z"
                  />
                  <path className={styles.st0} d="M63.2,294c0-1,0.9-1.7,1.9-1.7s1.8,0.8,1.8,1.8c0,0.9-0.9,1.7-1.9,1.7C64,295.8,63.2,295,63.2,294z" />
                  <path className={styles.st0}
                    d="M71,239.4c0.2-0.9,1.2-1.5,2.2-1.2c1,0.3,1.5,1.2,1.3,2.1c-0.2,0.9-1.2,1.5-2.2,1.2C71.4,241.3,70.7,240.3,71,239.4z"
                  />
                  <path className={styles.st0}
                    d="M66.5,332.7c2-0.2,3.6,1.1,3.9,2.9c0.3,1.8-1.1,3.5-3.1,3.8c-1.9,0.3-3.7-1-4-2.9C63,334.6,64.5,332.9,66.5,332.7z"
                  />
                  <path className={styles.st0}
                    d="M64.9,305.4c2,0,3.6,1.5,3.6,3.3c0,1.8-1.5,3.4-3.5,3.5s-3.6-1.4-3.6-3.3C61.3,306.9,62.9,305.4,64.9,305.4z"
                  />
                  <path className={styles.st0}
                    d="M63.7,321.7c-0.1-1,0.7-1.8,1.7-1.9s1.9,0.7,1.9,1.6c0.1,0.9-0.7,1.8-1.7,1.9C64.6,323.4,63.7,322.7,63.7,321.7z"
                  />
                  <path className={styles.st0} d="M67,349.1c-0.2-1,0.5-1.9,1.5-2c1-0.2,1.9,0.5,2.1,1.4c0.2,0.9-0.5,1.8-1.5,2S67.2,350.1,67,349.1z" />
                </g>
              </g>
              <g>
                <g>
                  <path className={styles.st0}
                    d="M101.2,171.1c1.7,1,2.3,3.1,1.4,4.7c-0.9,1.6-3.1,2.1-4.8,1.2s-2.3-3.1-1.4-4.7C97.4,170.6,99.5,170.1,101.2,171.1z"
                  />
                  <path className={styles.st0}
                    d="M116.4,148.4c1.6,1.2,2,3.4,0.9,4.8c-1.1,1.5-3.2,1.8-4.8,0.7c-1.6-1.1-2-3.3-0.9-4.9C112.7,147.5,114.8,147.2,116.4,148.4z"
                  />
                  <path className={styles.st0}
                    d="M105.6,160.7c0.5-0.8,1.6-1,2.5-0.5c0.8,0.6,1.1,1.7,0.6,2.5c-0.5,0.8-1.6,1-2.5,0.5C105.4,162.6,105.1,161.5,105.6,160.7z"
                  />
                  <path className={styles.st0}
                    d="M88.5,195.4c1.8,0.8,2.6,2.9,1.9,4.5c-0.8,1.7-2.8,2.4-4.6,1.6c-1.8-0.8-2.6-2.8-1.9-4.5C84.6,195.3,86.7,194.5,88.5,195.4z"
                  />

                  <ellipse transform="matrix(0.4569 -0.8895 0.8895 0.4569 -114.1705 183.7095)" className={styles.st0} cx="93.4" cy="185.4" rx="1.7" ry="1.8" />
                  <path className={styles.st0}
                    d="M122,138.3c0.6-0.8,1.7-0.8,2.5-0.2c0.8,0.6,0.9,1.7,0.3,2.5c-0.6,0.7-1.7,0.8-2.5,0.2C121.5,140.2,121.4,139.1,122,138.3z"
                  />
                  <path className={styles.st0}
                    d="M78.3,220.9c1.9,0.6,2.9,2.6,2.3,4.3c-0.3,0.9-0.9,1.5-1.8,1.9c-0.8,0.4-1.7,0.5-2.7,0.2c-0.9-0.3-1.7-0.9-2.1-1.7c-0.4-0.8-0.5-1.7-0.2-2.6C74.5,221.3,76.5,220.3,78.3,220.9z"
                  />
                  <path className={styles.st0}
                    d="M88.4,195.5c1.8,0.8,2.6,2.9,1.9,4.5c-0.8,1.7-2.8,2.4-4.6,1.6c-1.8-0.8-2.6-2.8-1.9-4.5C84.6,195.4,86.6,194.7,88.4,195.5z"
                  />
                  <path className={styles.st0}
                    d="M80.4,209.8c0.4-0.9,1.4-1.3,2.3-1c0.9,0.4,1.4,1.4,1.1,2.3c-0.3,0.9-1.4,1.3-2.3,1C80.5,211.7,80.1,210.7,80.4,209.8z"
                  />
                  <path className={styles.st0}
                    d="M71.9,236c0.3-0.9,1.3-1.5,2.2-1.2c1,0.3,1.5,1.2,1.3,2.1c-0.3,0.9-1.3,1.4-2.2,1.2C72.2,237.9,71.6,236.9,71.9,236z"
                  />
                </g>
              </g>
              <g>
                <g>
                  <path className={styles.st0}
                    d="M178.2,89.3c1.1,1.6,0.8,3.8-0.7,4.9c-1.5,1.1-3.6,0.6-4.8-1c-1.2-1.6-0.8-3.8,0.7-4.9C175,87.2,177.1,87.6,178.2,89.3z"
                  />
                  <path className={styles.st0}
                    d="M201.7,75.1c0.9,1.7,0.3,3.8-1.2,4.7c-1.6,0.9-3.7,0.3-4.7-1.4c-1-1.7-0.4-3.9,1.2-4.8C198.6,72.6,200.7,73.3,201.7,75.1z"
                  />
                  <path className={styles.st0}
                    d="M186.6,81.7c0.8-0.5,1.9-0.2,2.4,0.6c0.5,0.9,0.3,2-0.5,2.5c-0.8,0.5-1.9,0.2-2.4-0.6S185.8,82.2,186.6,81.7z"
                  />
                  <path className={styles.st0}
                    d="M156.5,105.9c1.3,1.5,1.2,3.7-0.2,4.9c-1.4,1.2-3.6,1-4.9-0.5c-1.3-1.5-1.2-3.7,0.2-4.9C153,104.2,155.2,104.4,156.5,105.9z"
                  />
                  <path className={styles.st0}
                    d="M164,97.4c0.8-0.6,1.9-0.4,2.5,0.4c0.6,0.8,0.5,1.9-0.2,2.5c-0.7,0.6-1.9,0.4-2.5-0.4C163.2,99.2,163.3,98,164,97.4z"
                  />
                  <path className={styles.st0}
                    d="M210.9,68.3c0.9-0.4,1.9,0,2.4,0.9s0.1,2-0.8,2.4c-0.9,0.4-1.9,0-2.3-0.9C209.7,69.8,210,68.7,210.9,68.3z"
                  />
                  <path className={styles.st0}
                    d="M136.5,124.8c1.4,1.4,1.5,3.5,0.3,4.9c-1.3,1.3-3.5,1.3-4.9,0c-1.5-1.3-1.6-3.5-0.3-4.9C132.8,123.4,135.1,123.4,136.5,124.8z"
                  />
                  <path className={styles.st0}
                    d="M156.4,106c1.3,1.5,1.2,3.7-0.2,4.9c-1.4,1.2-3.6,1-4.9-0.5c-1.3-1.5-1.2-3.7,0.2-4.9C152.9,104.3,155.1,104.5,156.4,106z"
                  />
                  <path className={styles.st0}
                    d="M143.1,115.6c0.7-0.7,1.8-0.6,2.5,0.1s0.7,1.9,0,2.5c-0.7,0.7-1.8,0.6-2.5-0.1C142.4,117.3,142.4,116.2,143.1,115.6z"
                  />
                  <path className={styles.st0}
                    d="M124.2,135.7c0.6-0.7,1.8-0.8,2.5-0.1c0.8,0.7,0.9,1.8,0.3,2.5s-1.8,0.8-2.5,0.1S123.6,136.4,124.2,135.7z"
                  />
                </g>
              </g>
              <g>
                <g>
                  <path className={styles.st0}
                    d="M282.7,47.8c0.3,1.9-0.9,3.8-2.7,4.1c-1.8,0.3-3.6-1-3.9-2.9s0.9-3.8,2.7-4.1C280.6,44.5,282.4,45.8,282.7,47.8z"
                  />
                  <path className={styles.st0}
                    d="M309.9,44.8c0.1,2-1.3,3.7-3.1,3.8c-1.8,0.1-3.5-1.3-3.6-3.3s1.2-3.7,3.1-3.8C308.2,41.4,309.8,42.9,309.9,44.8z"
                  />
                  <path className={styles.st0} d="M293.5,44.5c1-0.1,1.8,0.6,1.9,1.6c0.1,1-0.6,1.9-1.5,2c-0.9,0.1-1.8-0.6-1.9-1.6S292.6,44.6,293.5,44.5z" />
                  <path className={styles.st0}
                    d="M255.9,53.5c0.5,1.9-0.5,3.8-2.3,4.3c-1.8,0.5-3.7-0.6-4.2-2.5c-0.6-1.9,0.5-3.8,2.3-4.3C253.5,50.5,255.4,51.6,255.9,53.5z"
                  />
                  <path className={styles.st0}
                    d="M266.3,49.1c0.9-0.2,1.9,0.4,2.1,1.4c0.2,1-0.4,2-1.3,2.2c-0.9,0.2-1.9-0.4-2.1-1.4C264.8,50.3,265.4,49.3,266.3,49.1z"
                  />
                  <path className={styles.st0} d="M321.2,42.7c1,0,1.7,0.8,1.8,1.8c0,1-0.8,1.8-1.7,1.9s-1.7-0.8-1.8-1.8S320.2,42.7,321.2,42.7z" />
                  <path className={styles.st0}
                    d="M229.8,62.2c0.7,1.8-0.1,3.9-1.8,4.5c-1.7,0.7-3.7-0.2-4.5-2.1c-0.8-1.8,0-3.8,1.8-4.5C227.1,59.4,229.1,60.3,229.8,62.2z"
                  />
                  <path className={styles.st0}
                    d="M255.8,53.6c0.5,1.9-0.5,3.8-2.3,4.3c-1.8,0.5-3.7-0.6-4.2-2.5c-0.6-1.9,0.5-3.8,2.3-4.3C253.4,50.5,255.3,51.7,255.8,53.6z"
                  />

                  <ellipse transform="matrix(0.9465 -0.3227 0.3227 0.9465 -5.9692 80.6534)" className={styles.st0} cx="240.3" cy="58.3" rx="1.7" ry="1.8" />
                  <path className={styles.st0} d="M214.1,66.9c0.9-0.4,1.9,0,2.3,0.9s0.1,2-0.8,2.4c-0.9,0.4-1.9,0-2.3-0.9S213.2,67.3,214.1,66.9z" />
                </g>
              </g>
              <g>
                <g>
                  <path className={styles.st0}
                    d="M394.9,54.4c-0.5,1.9-2.4,3-4.2,2.5c-1.8-0.5-2.8-2.5-2.3-4.3c0.5-1.9,2.4-3,4.2-2.5C394.4,50.5,395.4,52.5,394.9,54.4z"
                  />
                  <path className={styles.st0}
                    d="M420.8,63.3c-0.7,1.8-2.7,2.7-4.4,2.1c-1.7-0.7-2.5-2.7-1.9-4.6s2.7-2.8,4.4-2.1C420.7,59.4,421.5,61.4,420.8,63.3z"
                  />
                  <path className={styles.st0} d="M406.1,55.9c0.9,0.3,1.4,1.3,1.1,2.3s-1.3,1.5-2.2,1.2c-0.9-0.3-1.4-1.3-1.1-2.3S405.2,55.6,406.1,55.9z" />
                  <path className={styles.st0}
                    d="M368.2,48.3c-0.3,1.9-2.1,3.2-3.9,2.9c-1.8-0.4-3.1-2.1-2.8-4c0.3-1.9,2-3.4,3.9-3C367.3,44.5,368.5,46.4,368.2,48.3z"
                  />
                  <path className={styles.st0}
                    d="M379.5,48.6c0.9,0.2,1.5,1.2,1.3,2.2c-0.2,1-1.2,1.6-2.1,1.4c-0.9-0.2-1.5-1.2-1.3-2.2C377.7,49,378.6,48.4,379.5,48.6z"
                  />

                  <ellipse transform="matrix(0.4145 -0.91 0.91 0.4145 190.7966 431.9993)" className={styles.st0} cx="431.1" cy="67.7" rx="1.8" ry="1.7" />
                  <path className={styles.st0}
                    d="M340.9,45.1c-0.1,2-1.7,3.4-3.6,3.3c-1.8-0.1-3.3-1.7-3.2-3.7c0.1-2,1.7-3.5,3.6-3.5C339.6,41.4,341,43.1,340.9,45.1z"
                  />
                  <path className={styles.st0}
                    d="M368.1,48.3c-0.3,1.9-2.1,3.2-3.9,2.9c-1.8-0.4-3.1-2-2.8-4c0.3-1.9,2-3.4,3.9-3C367.2,44.5,368.4,46.4,368.1,48.3z"
                  />
                  <path className={styles.st0}
                    d="M352.2,44.2c1,0.1,1.6,1,1.5,2c-0.1,1-1,1.7-1.9,1.6c-0.9-0.1-1.6-1-1.5-2C350.4,44.8,351.2,44.1,352.2,44.2z"
                  />
                  <path className={styles.st0}
                    d="M324.7,42.7c1,0,1.7,0.9,1.7,1.9c0,1-0.8,1.8-1.7,1.8c-0.9,0-1.7-0.8-1.7-1.8C322.9,43.5,323.7,42.6,324.7,42.7z"
                  />
                </g>
              </g>
              <g>
                <g>
                  <path className={styles.st0}
                    d="M493.7,107.9c-1.3,1.5-3.5,1.7-4.9,0.5c-1.4-1.2-1.5-3.4-0.3-4.9c1.3-1.5,3.4-1.7,4.9-0.5C494.9,104.3,495,106.5,493.7,107.9z"
                  />
                  <path className={styles.st0}
                    d="M513.4,127c-1.4,1.3-3.6,1.3-4.9,0c-1.3-1.3-1.2-3.5,0.2-4.9s3.6-1.4,4.9,0C514.9,123.4,514.8,125.6,513.4,127z"
                  />
                  <path className={styles.st0}
                    d="M503.2,114.1c0.7,0.7,0.7,1.8,0,2.5s-1.8,0.8-2.5,0.1c-0.7-0.7-0.7-1.8,0-2.5C501.4,113.5,502.5,113.4,503.2,114.1z"
                  />
                  <path className={styles.st0}
                    d="M472.1,91.1c-1.1,1.6-3.3,2-4.8,1c-1.5-1.1-1.9-3.1-0.8-4.8c1.1-1.6,3.3-2.2,4.8-1.1C472.9,87.3,473.2,89.5,472.1,91.1z"
                  />
                  <path className={styles.st0} d="M482.2,96.2c0.8,0.6,0.9,1.7,0.3,2.5s-1.7,1-2.5,0.4s-0.9-1.7-0.3-2.5C480.4,95.8,481.5,95.6,482.2,96.2z" />
                  <path className={styles.st0}
                    d="M522.3,134.2c0.6,0.7,0.5,1.8-0.2,2.5c-0.8,0.6-1.9,0.6-2.5-0.1s-0.5-1.8,0.2-2.5S521.6,133.5,522.3,134.2z"
                  />
                  <path className={styles.st0}
                    d="M448.8,76.5c-1,1.7-3,2.3-4.7,1.5c-1.6-0.8-2.2-2.9-1.3-4.7c0.9-1.7,3-2.5,4.7-1.6C449.2,72.6,449.7,74.8,448.8,76.5z"
                  />
                  <path className={styles.st0}
                    d="M472,91c-1.1,1.6-3.3,2-4.8,1c-1.5-1-1.9-3.1-0.8-4.8c1.1-1.6,3.3-2.2,4.8-1.1C472.8,87.2,473.1,89.4,472,91z"
                  />
                  <path className={styles.st0}
                    d="M459.4,80.5c0.8,0.5,1,1.6,0.5,2.5c-0.5,0.9-1.6,1.1-2.4,0.6c-0.8-0.5-1.1-1.6-0.5-2.4C457.5,80.4,458.6,80,459.4,80.5z"
                  />
                  <path className={styles.st0}
                    d="M435.1,67.5c0.9,0.4,1.2,1.5,0.8,2.4c-0.4,0.9-1.5,1.3-2.4,0.9c-0.9-0.4-1.2-1.4-0.8-2.4C433.1,67.5,434.2,67.1,435.1,67.5z"
                  />
                </g>
              </g>
              <g>
                <g>
                  <path className={styles.st0}
                    d="M560.6,198.2c-1.8,0.8-3.9,0.1-4.6-1.6c-0.8-1.7,0.1-3.7,1.8-4.6c1.8-0.9,3.8-0.1,4.6,1.6C563.2,195.4,562.4,197.4,560.6,198.2z"
                  />
                  <path className={styles.st0}
                    d="M570.4,223.8c-1.9,0.6-3.9-0.3-4.5-2.1s0.4-3.7,2.3-4.3s3.8,0.3,4.5,2.1C573.3,221.3,572.3,223.2,570.4,223.8z"
                  />

                  <ellipse transform="matrix(0.9302 -0.367 0.367 0.9302 -37.107 221.8797)" className={styles.st0} cx="564.9" cy="208.5" rx="1.8" ry="1.7" />
                  <path className={styles.st0}
                    d="M548.1,173.9c-1.7,1-3.8,0.5-4.7-1.1c-0.9-1.6-0.4-3.7,1.3-4.7c1.7-1,3.9-0.6,4.8,1.1C550.5,170.7,549.9,172.9,548.1,173.9z"
                  />
                  <path className={styles.st0}
                    d="M555.1,182.8c0.4,0.9,0.1,1.9-0.8,2.4c-0.9,0.5-2,0.1-2.4-0.7c-0.4-0.8-0.1-1.9,0.8-2.4C553.6,181.6,554.7,181.9,555.1,182.8z"
                  />
                  <path className={styles.st0}
                    d="M575.4,234.1c0.3,0.9-0.3,1.9-1.3,2.2c-1,0.3-2-0.3-2.2-1.2c-0.3-0.9,0.3-1.9,1.3-2.2S575.1,233.2,575.4,234.1z"
                  />
                  <path className={styles.st0}
                    d="M533.1,150.8c-1.6,1.2-3.7,0.9-4.8-0.6c-1.1-1.4-0.8-3.6,0.8-4.8c1.6-1.2,3.8-1,4.9,0.5C535.1,147.5,534.7,149.7,533.1,150.8z"
                  />
                  <path className={styles.st0}
                    d="M548.1,173.8c-1.7,1-3.8,0.5-4.7-1.1c-0.9-1.6-0.4-3.7,1.3-4.7c1.7-1,3.9-0.6,4.8,1.1C550.4,170.6,549.8,172.8,548.1,173.8z"
                  />
                  <path className={styles.st0}
                    d="M541,158.9c0.5,0.8,0.3,1.9-0.6,2.5c-0.8,0.6-1.9,0.4-2.5-0.4c-0.5-0.8-0.3-1.9,0.6-2.5C539.4,157.9,540.5,158.1,541,158.9z"
                  />
                  <path className={styles.st0}
                    d="M524.6,136.8c0.6,0.7,0.5,1.9-0.3,2.5c-0.8,0.6-1.9,0.5-2.5-0.2c-0.6-0.7-0.5-1.8,0.3-2.5C522.8,136,523.9,136.1,524.6,136.8z"
                  />
                </g>
              </g>
              <g>
                <g>
                  <path className={styles.st0}
                    d="M582.9,308.4c-2,0-3.5-1.6-3.5-3.4c0.1-1.8,1.6-3.3,3.5-3.4c1.9,0,3.6,1.5,3.6,3.4C586.5,306.9,584.8,308.4,582.9,308.4z"
                  />
                  <path className={styles.st0}
                    d="M581,335.7c-2-0.2-3.3-1.9-3.1-3.8c0.2-1.8,1.9-3.2,3.9-3s3.4,1.9,3.2,3.8C584.7,334.6,582.9,336,581,335.7z"
                  />
                  <path className={styles.st0}
                    d="M584.3,319.6c-0.1,1-0.9,1.7-1.9,1.6c-1-0.1-1.8-0.9-1.7-1.8c0.1-0.9,0.9-1.7,1.9-1.6C583.5,317.9,584.3,318.7,584.3,319.6z"
                  />
                  <path className={styles.st0}
                    d="M581.9,281c-2,0.2-3.7-1.2-3.8-3c-0.2-1.8,1.2-3.5,3.1-3.7c1.9-0.2,3.8,1.1,3.9,3C585.4,279.2,583.9,280.9,581.9,281z"
                  />
                  <path className={styles.st0} d="M584.5,292.1c0,1-0.8,1.8-1.8,1.8c-1,0-1.8-0.7-1.9-1.7c0-0.9,0.8-1.8,1.8-1.8S584.5,291.1,584.5,292.1z" />
                  <path className={styles.st0}
                    d="M581.1,347.2c-0.2,1-1.1,1.6-2.1,1.4c-1-0.2-1.7-1.1-1.5-2c0.2-0.9,1.1-1.6,2.1-1.4C580.6,345.3,581.3,346.2,581.1,347.2z"
                  />
                  <path className={styles.st0}
                    d="M578.1,253.8c-1.9,0.4-3.7-0.8-4.1-2.6c-0.4-1.8,0.8-3.6,2.7-4c1.9-0.4,3.8,0.7,4.2,2.6C581.4,251.6,580.1,253.4,578.1,253.8z"
                  />
                  <path className={styles.st0}
                    d="M581.9,280.9c-2,0.2-3.7-1.2-3.8-3c-0.2-1.8,1.2-3.5,3.1-3.7c1.9-0.2,3.8,1.1,3.9,3C585.4,279.1,583.9,280.7,581.9,280.9z"
                  />
                  <path className={styles.st0}
                    d="M581.9,264.5c0.1,1-0.6,1.8-1.6,2c-1,0.1-1.9-0.5-2-1.4c-0.1-0.9,0.5-1.8,1.5-2C580.8,262.9,581.8,263.5,581.9,264.5z"
                  />
                  <path className={styles.st0}
                    d="M576.3,237.5c0.3,0.9-0.4,1.9-1.3,2.1c-1,0.2-1.9-0.3-2.2-1.2c-0.3-0.9,0.3-1.9,1.3-2.1C575.1,236,576.1,236.6,576.3,237.5z"
                  />
                </g>
              </g>
              <g>
                <g>
                  <path className={styles.st0}
                    d="M556.5,417.7c-1.8-0.9-2.5-2.9-1.8-4.6c0.8-1.7,2.9-2.3,4.7-1.5s2.6,2.9,1.8,4.6C560.4,417.8,558.3,418.5,556.5,417.7z"
                  />
                  <path className={styles.st0}
                    d="M543.1,441.5c-1.7-1.1-2.2-3.2-1.2-4.7c1-1.6,3.1-2,4.8-1c1.7,1,2.3,3.1,1.3,4.7C547,442.1,544.8,442.6,543.1,441.5z"
                  />
                  <path className={styles.st0}
                    d="M553,428.4c-0.5,0.8-1.6,1.1-2.5,0.6c-0.9-0.5-1.2-1.6-0.7-2.4c0.4-0.8,1.5-1.1,2.4-0.7C553.1,426.5,553.5,427.6,553,428.4z"
                  />
                  <path className={styles.st0}
                    d="M567.3,392.5c-1.8-0.7-2.9-2.6-2.3-4.4c0.6-1.7,2.6-2.6,4.5-2c1.9,0.6,2.9,2.6,2.3,4.4C571.1,392.2,569.2,393.2,567.3,392.5z"
                  />
                  <path className={styles.st0}
                    d="M564.9,403.5c-0.4,0.9-1.4,1.3-2.4,0.9c-0.9-0.4-1.4-1.4-1-2.3c0.4-0.9,1.4-1.3,2.4-0.9C564.9,401.6,565.3,402.7,564.9,403.5z"
                  />
                  <path className={styles.st0}
                    d="M538.4,452c-0.5,0.8-1.6,1-2.5,0.4c-0.8-0.6-1.1-1.7-0.5-2.5c0.5-0.8,1.6-1,2.5-0.4C538.7,450.1,539,451.2,538.4,452z"
                  />
                  <path className={styles.st0}
                    d="M575.3,366.2c-1.9-0.5-3-2.3-2.7-4.1c0.4-1.8,2.3-2.9,4.2-2.5c1.9,0.4,3.1,2.3,2.7,4.1C579.2,365.5,577.2,366.6,575.3,366.2z"
                  />
                  <path className={styles.st0}
                    d="M567.3,392.4c-1.8-0.7-2.9-2.6-2.3-4.4c0.6-1.7,2.6-2.6,4.5-2s2.9,2.6,2.3,4.4C571.2,392.1,569.2,393,567.3,392.4z"
                  />
                  <path className={styles.st0} d="M574.1,377.4c-0.3,0.9-1.3,1.4-2.2,1.1c-1-0.3-1.5-1.3-1.2-2.2s1.3-1.4,2.2-1.1S574.4,376.5,574.1,377.4z" />
                  <path className={styles.st0}
                    d="M580.5,350.6c-0.2,1-1.1,1.6-2.1,1.4c-1-0.2-1.7-1.1-1.5-2c0.2-0.9,1.1-1.6,2.1-1.4S580.7,349.7,580.5,350.6z"
                  />
                </g>
              </g>
            </g>
          </g>
        </g>
        <circle className={styles.st1} cx="603" cy="301.7" r="36.5" />
        <g>
          <path className={styles.st2}
            d="M603,338.7c-1,0-1.8,0-2.7-0.1c-1.9-0.1-3.8-0.4-5.8-0.9c-5.1-1.2-9.9-3.4-14.2-6.6c-9.7-7.3-15.3-18.4-15.3-30.5c0-20.9,17-38,38-38c20.9,0,38,17,38,38c0,12.3-6,23.9-16.1,31c-4.7,3.3-10.1,5.6-15.8,6.5c-1.8,0.3-3.7,0.5-5.5,0.5C603.4,338.7,603.2,338.7,603,338.7z"
          />
          <path className={styles.st0}
            d="M603,264.2c20.2,0,36.5,16.3,36.5,36.5c0,12.3-6.1,23.2-15.4,29.8c-4.4,3.1-9.6,5.3-15.2,6.2c-1.7,0.3-3.5,0.4-5.3,0.5c-0.2,0-0.4,0-0.6,0c-0.9,0-1.7,0-2.6-0.1c-1.9-0.1-3.8-0.4-5.6-0.8c-5-1.2-9.6-3.3-13.6-6.3c-8.9-6.7-14.7-17.3-14.7-29.3C566.5,280.6,582.8,264.2,603,264.2 M603,261.2c-21.8,0-39.5,17.7-39.5,39.5c0,12.6,5.8,24.1,15.9,31.7c4.4,3.3,9.4,5.6,14.7,6.8c2.1,0.5,4.1,0.8,6.1,0.9c0.9,0.1,1.8,0.1,2.8,0.1c0.2,0,0.5,0,0.7,0c1.9,0,3.8-0.2,5.7-0.5c5.9-1,11.6-3.3,16.4-6.7c10.5-7.4,16.7-19.5,16.7-32.3C642.5,279,624.8,261.2,603,261.2L603,261.2z"
          />
        </g>
        <g>
          <path className={styles.st3}
            d="M624.1,330.5c-4.4,3.1-9.6,5.3-15.2,6.2c-1.7,0.3-3.5,0.4-5.3,0.5c-0.2,0-0.4,0-0.6,0c-0.9,0-1.7,0-2.6-0.1c-1.9-0.1-3.8-0.4-5.6-0.8c-5-1.2-9.6-3.3-13.6-6.3c0.6-0.6,1.4-1.1,2.2-1.4l5.3-1.9l2.6-0.9l2.8,1.8l0.4,0.3l0,0c0.7,0.7,1.2-2.4,1.8-5.6c0.2-0.9,0.3-1.7,0.5-2.5v0c0.5-2.4,1.1-4.5,1.9-4.5h6.5c0.8,0,1.5,2.1,2.1,4.7c0.2,0.8,0.4,1.7,0.6,2.5c0.5,2.3,1,4.5,1.5,5.4c0.1,0.1,0.1,0.2,0.2,0.3c0.2,0.2,0.3,0.3,0.5,0.1l2.3-2.7l2.8,1l6,2.1C622.4,329,623.3,329.7,624.1,330.5z"
          />
          <path className={styles.st4}
            d="M610.2,316.1l-0.1,5.3l-0.1,5.3c0,4.2-8,9.2-8,9.2s-8-5-8-9.2l0.1-5.6l0.1-5c0-4.2,3.6-7.7,8-7.7c2.2,0,4.2,0.9,5.7,2.2C609.3,312,610.2,313.9,610.2,316.1z"
          />
          <path className={styles.st5}
            d="M610.2,316.1l-0.1,5.3c-2.3,1.3-4.9,2.1-7.7,2.1c-3.1,0-5.9-0.9-8.3-2.5l0.1-5c0-4.2,3.6-7.7,8-7.7c2.2,0,4.2,0.9,5.7,2.2C609.3,312,610.2,313.9,610.2,316.1z"
          />
          <path className={styles.st6}
            d="M617.7,293.3v12.1c0,8.4-6.8,15.3-15.3,15.3c-8.4,0-15.3-6.8-15.3-15.3v-12.1c0-5.4,2.7-10.1,6.9-12.8c1.3-0.9,2.8-1.5,4.4-2c1.2-0.3,2.5-0.5,3.9-0.5c4.2,0,8,1.7,10.8,4.5c2.4,2.4,4,5.6,4.4,9.2C617.6,292.2,617.7,292.8,617.7,293.3z"
          />
          <circle className={styles.st7} cx="595.4" cy="298.8" r="1.9" />
          <circle className={styles.st7} cx="609.1" cy="298.8" r="1.9" />
          <path className={styles.st8} d="M595.3,305.5c0,3.9,3.2,7.1,7.1,7.1c3.9,0,7.1-3.2,7.1-7.1" />
          <path className={styles.st9}
            d="M601.1,335.2L601.1,335.2l-0.6,1.9c-1.9-0.1-3.8-0.4-5.6-0.8l-6.1-9.6l-0.1-0.1c-0.2-0.3-0.2-0.7,0.2-0.9l1.8-1.2c0.3-0.2,0.8-0.2,1,0.1l2.4,2.7l0.5,0.6l0,0L601.1,335.2z"
          />
          <path className={styles.st9}
            d="M615.4,326.5c0,0,0,0.1-0.1,0.1l-6.4,10.2c-1.7,0.3-3.5,0.4-5.3,0.5l-0.7-2v0l6.6-7.4l0.4-0.5l2.4-2.7c0.3-0.3,0.7-0.3,1-0.1l1.8,1.2C615.4,325.9,615.5,326.2,615.4,326.5z"
          />
          <circle className={styles.st6} cx="617.6" cy="301.5" r="3.4" />
          <circle className={styles.st6} cx="587.1" cy="301.5" r="3.4" />
          <path className={styles.st7}
            d="M587.1,306.7c0.8,0,1.4-0.6,1.4-1.4v-9.7c0-4.6,2.3-8.9,6.2-11.5c1.2-0.8,2.5-1.4,4-1.8c1.1-0.3,2.3-0.5,3.5-0.5c3.7,0,7.1,1.4,9.7,4c2.2,2.2,3.6,5.1,3.9,8.2c0.1,0.5,0.1,0.9,0.1,1.5v9.7c0,0.8,0.6,1.4,1.4,1.4l0,0c0.8,0,1.4-0.6,1.4-1.4v-9.7c0-0.6,0-1.2-0.1-1.7c-0.4-3.9-2.1-7.3-4.7-9.9c-3-3-7.1-4.8-11.7-4.8c-1.5,0-2.9,0.2-4.2,0.6c-1.7,0.5-3.3,1.2-4.8,2.1c-4.5,3-7.5,8-7.5,13.8v9.7C585.7,306,586.3,306.7,587.1,306.7L587.1,306.7z"
          />

          <ellipse transform="matrix(0.1484 -0.9889 0.9889 0.1484 232.3906 844.7093)" className={styles.st7} cx="606.6" cy="287.4" rx="5.3" ry="10.9" />
          <line className={styles.st10} x1="591.8" y1="295.5" x2="596.9" y2="294.1" />
          <line className={styles.st10} x1="612.6" y1="295.3" x2="607.5" y2="293.9" />
          <path className={styles.st6}
            d="M617.3,293.8l0,2.7c-0.3-0.2-0.5-0.5-0.8-0.7c-8.3-6.6-20.7-6.2-29,0.4c-0.1,0.1-0.3,0.2-0.4,0.3l0.1-2.9C597.1,286.6,607.8,286.1,617.3,293.8z"
          />
          <g>
            <path className={styles.st11}
              d="M621.1,291.1c-0.4-4.2-0.8-8.6-3.7-11.5c-3.3-3.3-9.3-4.7-14.3-4.7c0,0-0.1,0-0.1,0c0,0-0.1,0-0.1,0c-5,0-11,1.4-14.3,4.7c-2.9,2.9-3.3,7.3-3.7,11.5c-0.1,0.6-0.1,1.3-0.1,1.9v1.8c5.5-3.5,11.9-5.3,18.2-5.2c6.3-0.1,12.7,1.6,18.2,5.2V293C621.2,292.4,621.2,291.7,621.1,291.1z"
            />
            <path className={styles.st12}
              d="M618,292.1c-4.6-2-9.5-3-14.5-3h-0.9c-5,0-10,1-14.5,3c0.4-3.2,0.9-8.6,2.7-10.4c2.6-2.6,7.9-3.8,12.1-3.8l0.2,0c0.1,0,0.2,0,0.3,0c4.2,0,9.5,1.2,12.1,3.8C617.1,283.5,617.6,288.9,618,292.1z"
            />
            <path className={styles.st13}
              d="M622.1,296C622.1,296,622.1,296,622.1,296c-0.4,0.5-1,0.6-1.4,0.2c-0.2-0.2-0.5-0.4-0.7-0.6c-0.8-0.6-1.7-1.2-2.6-1.8c-9-5.6-19.9-5.6-28.9,0c-1.1,0.7-2.2,1.5-3.2,2.3c0,0,0,0-0.1,0c-0.5,0.4-1.1,0.3-1.4-0.2c0,0,0,0,0,0c-0.4-0.5-0.3-1.2,0.2-1.6c0.4-0.3,0.8-0.6,1.2-0.9c0,0,0.1-0.1,0.1-0.1c10.5-7.9,24.1-8,34.7-0.5c0,0,0.1,0.1,0.1,0.1c0.6,0.4,1.3,0.9,1.9,1.4C622.4,294.8,622.5,295.5,622.1,296z"
            />
            <ellipse className={styles.st13} cx="603" cy="274.9" rx="2" ry="1.4" />
          </g>
          <path className={styles.st14} d="M601.8,301.6c1.2-0.3,2.4,0.2,2.6,1.1s-0.5,2-1.7,2.3" />
        </g>
        <path className={styles.st15} d="M166.3,15.1" />
        <g>
          <path className={styles.st2}
            d="M186.3,112.3c-0.8,0-1.6,0-2.3-0.1c-0.5,0-1-0.1-1.6-0.1c-1-0.1-2.1-0.3-3.3-0.5c-5.4-1-10.3-3.1-14.8-6.3c-0.1-0.1-0.2-0.2-0.4-0.3c-9.8-7.1-15.6-18.6-15.6-30.7c0-21,17-38,38-38c21,0,38,17,38,38c0,12.1-5.6,23.2-15.2,30.4c0,0-0.2,0.2-0.3,0.2c-1.4,1-2.8,1.9-4.3,2.7c-3.3,1.8-6.7,3.1-10.3,3.8c-1.2,0.3-2.6,0.5-3.9,0.6c-0.5,0.1-1.1,0.1-1.7,0.1C187.9,112.3,187.1,112.3,186.3,112.3z"
          />
          <path className={styles.st0}
            d="M186.3,37.8c20.2,0,36.5,16.3,36.5,36.5c0,12-5.8,22.6-14.6,29.2c-0.1,0-0.1,0.1-0.2,0.1c0,0,0,0-0.1,0c-1.3,1-2.7,1.9-4.2,2.7c-3.1,1.7-6.4,2.9-9.9,3.7c-1.2,0.3-2.5,0.5-3.8,0.6c-0.5,0.1-1.1,0.1-1.6,0.1c-0.7,0.1-1.5,0.1-2.2,0.1c-0.7,0-1.5,0-2.2-0.1c-0.5,0-1-0.1-1.5-0.1c-1.1-0.1-2.1-0.3-3.2-0.5c-5.2-1-10.1-3.1-14.2-6.1c-0.1-0.1-0.2-0.2-0.4-0.3c-9.1-6.6-15-17.4-15-29.5C149.8,54.1,166.1,37.8,186.3,37.8 M186.3,34.8c-21.8,0-39.5,17.7-39.5,39.5c0,12.6,6.1,24.5,16.3,31.9c0.1,0.1,0.3,0.2,0.4,0.3c4.6,3.3,9.8,5.5,15.4,6.6c1.2,0.2,2.3,0.4,3.4,0.5c0.6,0.1,1.1,0.1,1.7,0.1c0.7,0,1.5,0.1,2.4,0.1c0.9,0,1.6,0,2.4-0.1c0.6,0,1.2-0.1,1.7-0.1c1.4-0.1,2.7-0.4,4-0.6c3.8-0.8,7.4-2.1,10.7-4c1.5-0.8,2.9-1.7,4.3-2.7l0,0l0,0l0.1,0l0.2-0.2c0.1,0,0.1-0.1,0.1-0.1c10-7.5,15.8-19.1,15.8-31.6C225.8,52.5,208.1,34.8,186.3,34.8L186.3,34.8z"
          />
        </g>
        <g>
          <path className={styles.st4}
            d="M206.6,102.6c0.5,0.3,0.9,0.7,1.3,1.1c-1.3,1-2.7,1.9-4.2,2.7c-3.1,1.7-6.4,2.9-9.9,3.7c-0.1-1.6,0.2-3.2,1-4.6c2.2-4,7.2-5.4,11.2-3.1L206.6,102.6z"
          />
          <path className={styles.st16}
            d="M208,103.6c0.2,0.2,0.4,0.5,0.6,0.8C208.4,104.2,208.2,103.9,208,103.6c-1.4,1-2.8,1.9-4.2,2.7l2.3-4.1l0.5,0.3l0.9,0.6l0.6,0.4C208.1,103.6,208.1,103.6,208,103.6z"
          />
          <path className={styles.st4} d="M179.4,110.1c-5.2-1-10.1-3.1-14.2-6.1c2.6-2.8,7-3.5,10.4-1.4C178.2,104.4,179.6,107.2,179.4,110.1z" />
          <path className={styles.st3}
            d="M208.6,104.4c-0.2-0.3-0.4-0.5-0.6-0.8c-1.3,1-2.7,1.9-4.2,2.7c-3.1,1.7-6.4,2.9-9.9,3.7c-1.2,0.3-2.5,0.5-3.8,0.6c-0.5,0.1-1.1,0.1-1.6,0.1c-0.7,0.1-1.5,0.1-2.2,0.1c-0.7,0-1.5,0-2.2-0.1c-0.5,0-1-0.1-1.5-0.1c-1.1-0.1-2.1-0.3-3.2-0.5c-5.2-1-10.1-3.1-14.2-6.1c-0.1-0.1-0.2-0.2-0.4-0.3c0.7-0.9,1.6-1.6,2.7-1.9l6.8-2.4l3.2-1.1l0.2-0.1c0,0,0.1,0.1,0.1,0.1h0c0.5,0.3,1.1-1.2,1.8-3.1c0.3-0.8,0.5-1.6,0.8-2.4c0.8-2.2,1.6-4.3,2.5-4.3h6.5c0.9,0,1.8,2.2,2.6,4.5c0.3,0.8,0.6,1.7,0.9,2.4c0.7,1.9,1.3,3.3,1.9,2.6l0.2,0.1l0.2,0.1l3.6,1.3l6.8,2.4c0.8,0.3,1.4,0.7,2,1.3c0.2,0.2,0.3,0.3,0.5,0.5C208.2,103.9,208.4,104.1,208.6,104.4z"
          />
          <path className={styles.st4}
            d="M195.1,87.4v12.5c0,4.6-4.2,6.9-9,6.9c-4.9,0-8.6-2.3-8.6-6.9V87.4c0-4.6,3.9-8.4,8.8-8.4c2.4,0,4.6,0.9,6.2,2.5C194.1,83,195.1,85.1,195.1,87.4z"
          />
          <path className={styles.st5}
            d="M195.1,87.4v6.8c-2.5,1.6-5.4,2.5-8.6,2.5c-3.3,0-6.4-1-9-2.8v-6.6c0-4.6,3.9-8.4,8.8-8.4c2.4,0,4.6,0.9,6.2,2.5C194.1,83,195.1,85.1,195.1,87.4z"
          />
          <path className={styles.st6}
            d="M202.5,66.6V78c0,8.8-7.2,16-16,16c-8.8,0-16-7.2-16-16V66.6c0-5.6,2.9-10.5,7.3-13.4c1.4-0.9,3-1.6,4.6-2.1c1.3-0.4,2.7-0.5,4.1-0.5c4.4,0,8.4,1.8,11.3,4.7c2.5,2.5,4.2,5.9,4.6,9.6C202.5,65.5,202.5,66,202.5,66.6z"
          />
          <circle className={styles.st6} cx="202.5" cy="73.9" r="3.6" />
          <circle className={styles.st6} cx="170.5" cy="73.9" r="3.6" />
          <circle className={styles.st7} cx="179.2" cy="73.8" r="2" />
          <circle className={styles.st7} cx="193.5" cy="73.8" r="2" />
          <path className={styles.st17} d="M179.8,82.2c1.3,2.3,3.7,3.9,6.5,3.9s5.3-1.6,6.5-3.9" />
          <path className={styles.st18}
            d="M186.1,106.9l-2,3.9c-0.5,0-1-0.1-1.5-0.1l-8.3-11.2l-0.2-0.2c-0.1-0.1-0.1-0.3,0-0.4l2-1.8c0.1-0.1,0.3-0.1,0.4,0l0.9,0.9l0.3,0.4h0L186.1,106.9z"
          />
          <path className={styles.st18}
            d="M198.8,99.2l-0.2,0.2l-8.6,11.2c-0.5,0.1-1.1,0.1-1.6,0.1l-2.2-3.9l0,0l8.6-8.7l0.2-0.2l0.9-0.9c0.1-0.1,0.3-0.1,0.4,0l2.4,1.8C198.9,98.9,198.9,99.1,198.8,99.2z"
          />
          <line className={styles.st19} x1="186.3" y1="110.8" x2="186.3" y2="106.9" />
          <line className={styles.st10} x1="175.6" y1="70.1" x2="180.8" y2="68.7" />
          <path className={styles.st20}
            d="M171.4,79c0.8,0,1.4-0.6,1.4-1.4v-9.7c0-4.6,2.3-8.9,6.2-11.5c1.2-0.8,2.5-1.4,3.9-1.8c1.1-0.3,2.3-0.5,3.5-0.5c3.7,0,7.1,1.4,9.7,4c2.2,2.2,3.6,5.1,3.9,8.2c0.1,0.5,0.1,0.9,0.1,1.5v9.7c0,0.8,0.6,1.4,1.4,1.4h0c0.8,0,1.4-0.6,1.4-1.4v-9.7c0-0.6,0-1.2-0.1-1.7c-0.4-3.9-2.1-7.3-4.7-9.9c-3-3-7.1-4.8-11.7-4.8c-1.5,0-2.9,0.2-4.2,0.6c-1.7,0.5-3.3,1.2-4.8,2.1c-4.5,3-7.5,8-7.5,13.8v9.7C170,78.3,170.6,79,171.4,79L171.4,79z"
          />
          <line className={styles.st10} x1="196.5" y1="70" x2="191.3" y2="68.5" />
          <path className={styles.st21}
            d="M176.8,55.3c0,0-3.6-1.6-6.3,1.1s-3.8,6.3-2,10.7c0.9,2.1,1.1,1.8,1.1,1.8l1.7,2.4c0,0,1.3-8.6,4.8-11.9C177.2,58.3,177.6,56.7,176.8,55.3L176.8,55.3z"
          />
          <path className={styles.st21}
            d="M208.3,53.9c0,0,6.6,15.4-21,12.9c-14.6-1.3-14.9-7.8-14.9-7.8s2.7-15.7,14.9-11.4C207.5,54.6,208.3,53.9,208.3,53.9z"
          />
          <path className={styles.st14} d="M185.4,76.7c1.2-0.3,2.4,0.2,2.6,1.1c0.3,1-0.5,2-1.7,2.3" />
        </g>
        <g>
          <defs>
            <circle id="SVGID_1_" cx="44.8" cy="301.7" r="36.5" />
          </defs>
          <clipPath id="SVGID_2_">
            <use xlinkHref="#SVGID_1_" />
          </clipPath>
        </g>
        <g>
          <path className={styles.st2}
            d="M44.8,339.7c-2.2,0-4.5-0.2-6.7-0.6c-0.3-0.1-0.6-0.1-0.9-0.2l-0.5-0.1c-4-0.9-7.8-2.4-11.3-4.5l-0.2-0.1c-0.1-0.1-0.2-0.1-0.3-0.2c-11.2-7-17.9-19-17.9-32.3c0-20.9,17-38,38-38c21,0,38,17,38,38c0,13.4-6.8,25.5-18.3,32.5c-3.8,2.3-7.9,3.9-12.2,4.8l-0.1,0l-0.1,0C49.7,339.5,47.2,339.7,44.8,339.7z"
          />
          <path className={styles.st0}
            d="M44.8,265.2c20.2,0,36.5,16.3,36.5,36.5c0,13.2-7,24.8-17.6,31.2c-3.6,2.2-7.5,3.8-11.8,4.6c0,0,0,0-0.1,0c-2.3,0.5-4.7,0.7-7.1,0.7c-2.2,0-4.4-0.2-6.5-0.6c-0.3,0-0.6-0.1-0.9-0.2c-0.2,0-0.3-0.1-0.5-0.1C33,336.5,29.3,335,26,333c-0.2-0.1-0.3-0.2-0.5-0.3c-10.4-6.4-17.2-17.9-17.2-31C8.3,281.6,24.6,265.2,44.8,265.2 M44.8,262.2C23,262.2,5.3,280,5.3,301.7c0,13.7,7,26.3,18.6,33.5c0.1,0.1,0.2,0.1,0.4,0.2l0.1,0.1c3.7,2.2,7.7,3.8,11.8,4.7c0.1,0,0.2,0,0.3,0.1c0.1,0,0.1,0,0.2,0l0.1,0l0.1,0c0.3,0.1,0.7,0.1,1,0.2c2.3,0.4,4.6,0.6,7,0.6c2.5,0,5-0.2,7.4-0.7h0.1l0.3-0.1c4.5-0.9,8.8-2.6,12.7-5c11.9-7.2,19-19.9,19-33.8C84.3,280,66.6,262.2,44.8,262.2L44.8,262.2z"
          />
        </g>
        <g>
          <path className={styles.st7}
            d="M44.5,277.3L44.5,277.3c-9.5,0-17.2,7.7-17.2,17.2v19.9c0,5,4.1,9.1,9.1,9.1h16.2c5,0,9.1-4.1,9.1-9.1v-19.9C61.7,285,54,277.3,44.5,277.3z"
          />
          <path className={styles.st22}
            d="M54,329.7c0,1.6-0.4,3.6-1.1,5.7c0,0.1-0.1,0.2-0.1,0.3c-0.2,0.6-0.5,1.3-0.8,1.9c0,0,0,0-0.1,0c-2.3,0.5-4.7,0.7-7.1,0.7c-2.2,0-4.4-0.2-6.5-0.6c-0.3,0-0.6-0.1-0.9-0.2c-0.2,0-0.3-0.1-0.5-0.1c-0.9-1.9-1.5-3.9-1.8-5.6c-0.1-0.8-0.2-1.5-0.2-2.1c0-0.5,0-1,0.1-1.3c0.1-0.3,0.1-0.6,0.3-0.8c0.2-0.4,0.4-0.7,0.8-0.9c1.6-1.2,4.8-0.5,8.4-0.5c3.5,0,6.5-0.7,8.2,0.4c0.1,0,0.2,0.1,0.2,0.2c0.4,0.3,0.7,0.7,0.8,1.2c0.1,0.1,0.1,0.3,0.1,0.4C54,328.7,54,329.2,54,329.7z"
          />
          <path className={styles.st4}
            d="M38.3,337.7c-0.3,0-0.6-0.1-0.9-0.2c-0.2,0-0.3-0.1-0.5-0.1C33,336.5,29.3,335,26,333c0.4-0.4,0.8-0.8,1.3-1.2c2.4-1.6,5.5-1.6,7.8-0.1c0.1,0.1,0.2,0.2,0.3,0.2c0.6,0.5,1.2,1,1.6,1.7C37.9,334.9,38.3,336.3,38.3,337.7z"
          />
          <path className={styles.st3}
            d="M63.7,332.9c-3.6,2.2-7.5,3.8-11.8,4.6c0,0,0,0-0.1,0c-2.3,0.5-4.7,0.7-7.1,0.7c-2.2,0-4.4-0.2-6.5-0.6c-0.3,0-0.6-0.1-0.9-0.2c-0.2,0-0.3-0.1-0.5-0.1C33,336.5,29.3,335,26,333c-0.2-0.1-0.3-0.2-0.5-0.3c0.9-1.5,2.2-2.7,3.8-3.2l5.3-1.3c0,0,0,0,0.1-0.1c0.5-0.6,0.9-1.4,1.3-2.4c0.2-0.4,0.3-0.8,0.5-1.3c0.1-0.3,0.2-0.6,0.3-1c0-0.2,0.1-0.4,0.2-0.5c0.2-0.8,0.5-1.6,0.7-2.4c0.9-3.2,1.7-6,2.9-6h7.4c1.2,0,2.2,3,3.1,6.2c0.2,0.8,0.5,1.6,0.7,2.4c0,0.1,0,0.2,0.1,0.2c0.1,0.3,0.2,0.6,0.3,1c0.2,0.4,0.3,0.9,0.5,1.2c0.1,0.2,0.1,0.3,0.2,0.4c0,0,0,0,0,0c0.1,0.1,0.1,0.3,0.2,0.4c0.3,0.6,0.5,1,0.8,1.2c0.1,0.1,0.2,0.1,0.2,0.2l0.1,0l0.3,0.1l5.5,1.4C61.5,330.1,62.9,331.3,63.7,332.9z"
          />
          <path className={styles.st4}
            d="M44.2,334.7L44.2,334.7c-4.7,0-8.3-5.6-8.3-10.1v-8.7c0-4.5,3.8-8.1,8.5-8.1h0c4.7,0,8.5,3.6,8.5,8.1v8.7C52.9,329.1,48.9,334.7,44.2,334.7z"
          />
          <path className={styles.st3}
            d="M53.8,328.3H35.1c-0.5,0-0.9-0.4-0.9-0.9v-1.9c0-0.5,0.4-0.9,0.9-0.9h18.7c0.5,0,0.9,0.4,0.9,0.9v1.9C54.8,327.9,54.4,328.3,53.8,328.3z"
          />
          <path className={styles.st5}
            d="M60,297.3v12.3c0,8.5-6.9,15.4-15.4,15.4c-8.5,0-15.4-6.9-15.4-15.4v-12.3c0-5.4,2.8-10.2,7-12.9c1.4-0.9,2.9-1.6,4.5-2c1.3-0.3,2.6-0.5,4-0.5c4.3,0,8.1,1.7,10.9,4.5c2.4,2.4,4.1,5.7,4.4,9.3C60,296.2,60,296.8,60,297.3z"
          />
          <path className={styles.st3}
            d="M54.2,329.2c0,1.7-0.5,4-1.3,6.2c0,0.1-0.1,0.2-0.1,0.3c-0.2,0.6-0.5,1.3-0.8,1.9c-2.3,0.5-4.7,0.7-7.1,0.7c-2.2,0-4.4-0.2-6.5-0.6c-0.3,0-0.6-0.1-0.9-0.2c-0.9-1.8-1.6-3.7-1.9-5.5c-0.2-1-0.3-2-0.3-2.9c0-0.3,0-0.6,0-0.8c0-0.3,0.1-0.6,0.2-0.8c0.2-0.5,0.4-0.9,0.7-1.2c1.5-1.5,4.8-0.7,8.6-0.7c3.3,0,6.2-0.6,7.9,0.2c0.1,0,0.2,0.1,0.2,0.1c0.7,0.4,1.1,1.1,1.3,2.2c0,0.1,0,0.1,0,0.2C54.2,328.5,54.2,328.8,54.2,329.2z"
          />
          <path className={styles.st6}
            d="M60,294.6v12.3c0,8.5-6.9,15.4-15.4,15.4c-8.5,0-15.4-6.9-15.4-15.4v-12.3c0-5.4,2.8-10.2,7-12.9c1.4-0.9,2.9-1.6,4.5-2c1.3-0.3,2.6-0.5,4-0.5c4.3,0,8.1,1.7,10.9,4.5c2.4,2.4,4.1,5.7,4.4,9.3C60,293.5,60,294,60,294.6z"
          />
          <path className={styles.st17} d="M37.9,310c1.3,2.3,3.7,3.9,6.5,3.9s5.3-1.6,6.5-3.9" />
          <path className={styles.st7}
            d="M30.1,304.2c0.8,0,1.4-0.6,1.4-1.4v-9.4c0-4.5,2.2-8.6,6-11.1c1.2-0.8,2.5-1.3,3.8-1.7c1.1-0.3,2.2-0.4,3.4-0.4c3.5,0,6.9,1.4,9.4,3.9c2.2,2.1,3.5,5,3.8,7.9c0.1,0.5,0.1,0.9,0.1,1.4v9.4c0,0.8,0.6,1.4,1.4,1.4h0c0.8,0,1.4-0.6,1.4-1.4v-9.4c0-0.6,0-1.1-0.1-1.7c-0.4-3.7-2.1-7.1-4.6-9.6c-2.9-2.9-6.9-4.7-11.3-4.7c-1.4,0-2.8,0.2-4.1,0.5c-1.7,0.4-3.2,1.1-4.6,2.1c-4.4,2.9-7.9,8-7.9,13.6l0.6,9.2C28.8,303.6,29.4,304.2,30.1,304.2L30.1,304.2z"
          />
          <line className={styles.st10} x1="34.2" y1="296.3" x2="39.3" y2="294.9" />
          <line className={styles.st10} x1="55" y1="296.2" x2="49.9" y2="294.7" />
          <circle className={styles.st6} cx="60" cy="302.9" r="3.5" />
          <circle className={styles.st6} cx="29.2" cy="302.9" r="3.5" />
          <circle className={styles.st7} cx="37.6" cy="300.2" r="1.9" />
          <circle className={styles.st7} cx="51.4" cy="300.2" r="1.9" />
          <circle className={styles.st23} cx="60.6" cy="304.8" r="0.8" />
          <circle className={styles.st23} cx="28.8" cy="304.8" r="0.8" />
          <ellipse transform="matrix(0.19 -0.9818 0.9818 0.19 -243.6246 278.3428)" className={styles.st24} cx="46.9" cy="286.8" rx="8.4" ry="14.6" />
          <path className={styles.st14} d="M43.4,303.7c1.2-0.3,2.4,0.2,2.6,1.1s-0.5,2-1.7,2.3" />
        </g>
        <g>
          <path className={styles.st25} d="M355.8,21.2v41.4c0,1.8-1.5,3.3-3.3,3.3h-57.2c-1.8,0-3.3-1.5-3.3-3.3V21.2H355.8z" />
          <path className={styles.st25} d="M355.8,13.8v7.4H292v-7.4c0-1.4,1.1-2.5,2.5-2.5h58.8C354.7,11.3,355.8,12.4,355.8,13.8z" />
        </g>
        <g>
          <path className={styles.st25} d="M129.2,161.4v41.4c0,1.8-1.5,3.3-3.3,3.3H68.6c-1.8,0-3.3-1.5-3.3-3.3v-41.4H129.2z" />
          <path className={styles.st25} d="M129.2,154v7.4H65.3V154c0-1.4,1.1-2.5,2.5-2.5h58.8C128,151.5,129.2,152.6,129.2,154z" />
        </g>
        <g>
          <path className={styles.st25} d="M582.5,161.4v41.4c0,1.8-1.5,3.3-3.3,3.3H522c-1.8,0-3.3-1.5-3.3-3.3v-41.4H582.5z" />
          <path className={styles.st25} d="M582.5,154v7.4h-63.8V154c0-1.4,1.1-2.5,2.5-2.5H580C581.4,151.5,582.5,152.6,582.5,154z" />
        </g>
        <text transform="matrix(1 0 0 1 302.715 58.1494)" className={cn(styles.st0, styles.st26, styles.st27)}>12</text>
        <text transform="matrix(1 0 0 1 85.807 197.4827)" className={cn(styles.st0, styles.st26, styles.st27)}>4</text>
        <text transform="matrix(1 0 0 1 530.8834 196.4819)" className={cn(styles.st0, styles.st26, styles.st27)}>26</text>
        <g>
          <path className={styles.st28}
            d="M461.9,112.3c-0.4,0-0.8,0-1.2,0c-0.4,0-0.8,0-1.2-0.1c-1.8-0.1-3.6-0.3-5.4-0.7c-0.4-0.1-0.9-0.2-1.3-0.3c-3.5-0.8-6.7-2.1-9.8-3.9h0l-0.3-0.2c-1-0.6-1.9-1.2-2.9-1.9c-0.2-0.1-0.4-0.3-0.6-0.4c-9.7-7.3-15.3-18.4-15.3-30.5c0-21,17-38,38-38s38,17,38,38c0,11.9-5.7,23.3-15.3,30.5l-0.1,0.1l-0.1,0c-0.7,0.5-1.4,1-2.1,1.5c-2.9,1.9-6.1,3.3-9.4,4.3c-0.3,0.1-0.7,0.2-1,0.3c-2.1,0.6-4.3,1-6.5,1.2c-0.2,0-0.5,0.1-0.8,0.1C463.8,112.3,462.9,112.3,461.9,112.3z"
          />
          <path className={styles.st0}
            d="M461.9,37.8c20.2,0,36.5,16.3,36.5,36.5c0,12-5.8,22.7-14.7,29.3c0,0,0,0,0,0c-0.7,0.5-1.4,1-2.1,1.5c-2.8,1.8-5.8,3.2-9,4.1c-0.3,0.1-0.6,0.2-1,0.3c-2,0.6-4.1,0.9-6.2,1.1c-0.2,0-0.5,0-0.7,0.1c-0.9,0.1-1.8,0.1-2.7,0.1c-0.4,0-0.7,0-1.1,0c0,0,0,0,0,0c-0.4,0-0.7,0-1.1-0.1c-1.8-0.1-3.5-0.3-5.2-0.7c-0.4-0.1-0.9-0.2-1.3-0.3c-3.5-0.8-6.7-2.2-9.7-3.9c0,0,0,0,0,0c-1-0.6-1.9-1.2-2.8-1.8c-0.2-0.1-0.4-0.3-0.5-0.4c-8.9-6.7-14.7-17.3-14.7-29.3C425.4,54.1,441.7,37.8,461.9,37.8 M461.9,34.8c-21.8,0-39.5,17.7-39.5,39.5c0,12.6,5.8,24.1,15.9,31.7c0.2,0.2,0.4,0.3,0.6,0.5c1.1,0.8,2,1.4,3,2l0.7,0.4h0c3.1,1.7,6.4,3,9.8,3.8c0.5,0.1,0.9,0.2,1.4,0.3c1.8,0.4,3.7,0.6,5.6,0.7c0.4,0,0.9,0,1.2,0.1l0,0h0c0.4,0,0.8,0,1.2,0c1,0,1.9,0,2.9-0.1c0.3,0,0.6,0,0.8-0.1c2.3-0.2,4.5-0.6,6.7-1.2c0.4-0.1,0.7-0.2,1.1-0.3c3.4-1,6.7-2.5,9.7-4.5c0.7-0.5,1.4-0.9,2.1-1.4l0.2-0.1l0.2-0.2c9.9-7.4,15.8-19.2,15.8-31.6C501.4,52.5,483.6,34.8,461.9,34.8L461.9,34.8z"
          />
        </g>
        <g>
          <g>
            <path className={styles.st16}
              d="M483.6,103.6c-0.7,0.5-1.4,1-2.1,1.5c-2.8,1.8-5.8,3.2-9,4.1c-0.8-0.8-1.5-1.9-1.8-3.1c-0.9-3.5,1.3-7.1,4.8-8c0.8-0.2,1.6-0.2,2.3-0.2c2.7,0.3,5,2.2,5.7,5C483.5,103.2,483.6,103.4,483.6,103.6z"
            />
            <path className={styles.st16}
              d="M483.6,103.6C483.6,103.6,483.6,103.6,483.6,103.6c-0.7,0.5-1.4,1-2.1,1.5c-2.8,1.8-5.8,3.2-9,4.1c-0.3,0.1-0.6,0.2-1,0.3l-0.8-3.4l10.7-2.7l2.1-0.5L483.6,103.6z"
            />
          </g>
          <path className={styles.st7}
            d="M462.4,48.5L462.4,48.5c-8.9,0-16.2,7.2-16.2,16.2v15.5c0,8.9,7.2,16.2,16.2,16.2h0c8.9,0,16.2-7.2,16.2-16.2V64.7C478.6,55.8,471.3,48.5,462.4,48.5z"
          />
          <path className={styles.st22}
            d="M471.3,97.7c0,1.6-0.4,3.6-1.2,5.6c0,0.1-0.1,0.3-0.2,0.4c-1.1,2.8-2.7,5.5-4.7,6.9c-0.2,0-0.5,0-0.7,0.1c-0.9,0.1-1.8,0.1-2.7,0.1c-0.4,0-0.7,0-1.1,0c0,0,0,0,0,0c-0.4,0-0.7,0-1.1-0.1c-1.2-0.8-2.3-2.2-3.3-3.8c-1.4-2.3-2.3-5-2.7-7.3c-0.1-0.7-0.2-1.4-0.2-2c0-0.5,0-0.9,0.1-1.3c0.1-0.3,0.1-0.5,0.2-0.7v0c0.2-0.4,0.4-0.7,0.7-0.9c0.1-0.1,0.2-0.2,0.3-0.2c1.6-0.8,4.4-0.2,7.5-0.2c3.2,0,5.9-0.6,7.5,0.2c0.1,0,0.1,0.1,0.2,0.1c0.1,0,0.2,0.1,0.2,0.2c0.3,0.3,0.6,0.6,0.8,1.1c0,0.1,0.1,0.3,0.1,0.4C471.3,96.8,471.3,97.2,471.3,97.7z"
          />
          <path className={styles.st4}
            d="M456.5,106.4C456.5,106.4,456.5,106.4,456.5,106.4c0,0.2-0.1,0.4-0.1,0.6c-0.3,1.2-1,2.2-1.9,3.1c-0.4-0.1-0.9-0.2-1.3-0.3c-3.5-0.8-6.7-2.2-9.7-3.9c0,0,0-0.1,0-0.2v0c0-0.6,0-1.2,0.1-1.9c0.3-1.4,1.1-2.8,2.3-3.8l0.4-0.3c2.3-1.6,5.2-1.5,7.3-0.1c0.1,0.1,0.2,0.1,0.3,0.2c0.6,0.4,1.1,0.9,1.5,1.6C456.5,103,456.8,104.7,456.5,106.4z"
          />
          <path className={styles.st6}
            d="M453.2,109.8c-3.5-0.8-6.7-2.2-9.7-3.9c0,0,0,0,0,0c-1-0.6-1.9-1.2-2.8-1.8l3.7-2.7l1.6-1.2l0.4-0.3L453.2,109.8z"
          />
          <path className={styles.st6}
            d="M453.2,109.8c-3.5-0.8-6.7-2.2-9.7-3.9c0,0,0,0,0,0c-1-0.6-1.9-1.2-2.8-1.8l3.7-2.7l1.6-1.2l0.4-0.3L453.2,109.8z"
          />
          <path className={styles.st16}
            d="M453.2,109.8c-3.5-0.8-6.7-2.2-9.7-3.9c0,0,0,0,0,0c-1-0.6-1.9-1.2-2.8-1.8c-0.2-0.1-0.4-0.3-0.5-0.4l4.4-2.7l1.8-1.1L453.2,109.8z"
          />
          <path className={styles.st3}
            d="M481.5,105.1c-2.8,1.8-5.8,3.2-9,4.1c-0.3,0.1-0.6,0.2-1,0.3c-2,0.6-4.1,0.9-6.2,1.1c-0.2,0-0.5,0-0.7,0.1c-0.9,0.1-1.8,0.1-2.7,0.1c-0.4,0-0.7,0-1.1,0c0,0,0,0,0,0c-0.4,0-0.7,0-1.1-0.1c-1.8-0.1-3.5-0.3-5.2-0.7c-0.4-0.1-0.9-0.2-1.3-0.3c-3.5-0.8-6.7-2.2-9.7-3.9c0,0,0,0,0,0l0-0.2v0l0.1-1.1c0-0.3,0-0.5,0.1-0.8c0.1-0.9,0.3-1.8,0.7-2.5c0-0.1,0.1-0.2,0.2-0.4c0.8-1.6,2.1-2.8,3.7-3.3l5-1.2c0,0,0,0,0.1-0.1c0.4-0.5,0.8-1.2,1.1-2c0-0.1,0.1-0.1,0.1-0.2c0,0,0,0,0,0c0.2-0.4,0.3-0.8,0.4-1.2c0.3-0.9,0.6-1.9,0.9-2.9c0.1-0.2,0.1-0.5,0.2-0.7c0.8-3,1.6-5.6,2.7-5.6h6.9c1.1,0,2,2.9,2.9,5.8c0.1,0.2,0.1,0.5,0.2,0.7c0.3,0.9,0.5,1.8,0.8,2.6c0.1,0.4,0.3,0.8,0.4,1.2c0.1,0.1,0.1,0.3,0.2,0.4h0c0.1,0.1,0.1,0.3,0.2,0.4c0.2,0.5,0.5,0.9,0.8,1.1c0.1,0.1,0.2,0.1,0.2,0.2l0.1,0l0.2,0l5.2,1.3c0.3,0.1,0.6,0.3,0.9,0.4c1.9,1,3.2,3.1,3.6,5.5c0.1,0.4,0.1,0.7,0.1,1.1L481.5,105.1z"
          />
          <path className={styles.st4}
            d="M462.1,102.4L462.1,102.4c-4.4,0-7.8-5.3-7.8-9.5v-8.1c0-4.2,3.6-7.6,8-7.6l0,0c4.4,0,8,3.4,8,7.6v8.1C470.3,97.1,466.5,102.4,462.1,102.4z"
          />
          <path className={styles.st3}
            d="M471.1,96.4h-17.5c-0.5,0-0.9-0.4-0.9-0.9v-1.7c0-0.5,0.4-0.9,0.9-0.9h17.5c0.5,0,0.9,0.4,0.9,0.9v1.7C472,96,471.6,96.4,471.1,96.4z"
          />
          <path className={styles.st5}
            d="M477,65.6v11.5c0,8-6.5,14.5-14.5,14.5c-8,0-14.5-6.5-14.5-14.5V65.6c0-5.1,2.6-9.5,6.6-12.1c1.3-0.8,2.7-1.5,4.2-1.9c1.2-0.3,2.4-0.5,3.7-0.5c4,0,7.6,1.6,10.2,4.2c2.3,2.3,3.8,5.3,4.2,8.7C477,64.6,477,65.1,477,65.6z"
          />
          <path className={styles.st3}
            d="M471.5,97.2c0,1.7-0.5,3.9-1.4,6.1c0,0.1-0.1,0.3-0.2,0.4c-1.2,3-3.2,5.9-5.4,7c-0.9,0.1-1.8,0.1-2.7,0.1c-0.4,0-0.7,0-1.1,0c0,0,0,0,0,0c-1.6-0.7-3.1-2.4-4.2-4.4c0,0,0,0,0,0c-1.2-2-2.1-4.4-2.5-6.5c-0.2-1-0.3-1.9-0.3-2.7c0-0.3,0-0.5,0-0.8c0-0.3,0.1-0.5,0.1-0.7v0c0.2-0.5,0.4-0.9,0.7-1.2c0,0,0.1-0.1,0.1-0.1c1.5-1.3,4.5-0.6,8-0.6c3.1,0,5.8-0.5,7.4,0.2c0.1,0,0.2,0.1,0.2,0.1c0.1,0,0.1,0.1,0.2,0.1c0,0,0,0,0,0c0.5,0.4,0.9,1,1,1.9c0,0,0,0.1,0,0.2C471.5,96.6,471.5,96.9,471.5,97.2z"
          />
          <path className={styles.st6}
            d="M477,64.8v11.5c0,8-6.5,14.5-14.5,14.5c-8,0-14.5-6.5-14.5-14.5V64.8c0-5.1,2.6-9.5,6.6-12.1c1.3-0.8,2.7-1.5,4.2-1.9c1.2-0.3,2.4-0.5,3.7-0.5c4,0,7.6,1.6,10.2,4.2c2.3,2.3,3.8,5.3,4.2,8.7C477,63.7,477,64.2,477,64.8z"
          />
          <path className={styles.st17} d="M456.2,79.2c1.2,2.2,3.5,3.6,6.1,3.6s4.9-1.5,6.1-3.6" />
          <path className={styles.st7}
            d="M448.9,73.8c0.7,0,1.3-0.6,1.3-1.3v-8.8c0-4.2,2.1-8.1,5.6-10.4c1.1-0.7,2.3-1.3,3.6-1.6c1-0.3,2.1-0.4,3.2-0.4c3.3,0,6.4,1.3,8.8,3.6c2,2,3.3,4.7,3.6,7.5c0.1,0.4,0.1,0.9,0.1,1.3v8.8c0,0.7,0.6,1.3,1.3,1.3l0,0c0.7,0,1.3-0.6,1.3-1.3v-8.8c0-0.5,0-1.1-0.1-1.6c-0.4-3.5-1.9-6.7-4.3-9c-2.7-2.7-6.5-4.4-10.6-4.4c-1.3,0-2.6,0.2-3.8,0.5c-1.6,0.4-3,1.1-4.4,1.9c-4.1,2.7-7.4,7.5-7.4,12.7l0.6,8.6C447.6,73.2,448.2,73.8,448.9,73.8L448.9,73.8z"
          />
          <line className={styles.st10} x1="452.7" y1="66.4" x2="457.6" y2="65" />
          <line className={styles.st10} x1="472.3" y1="66.2" x2="467.4" y2="64.9" />
          <circle className={styles.st6} cx="477" cy="72.5" r="3.2" />
          <circle className={styles.st6} cx="448" cy="72.5" r="3.2" />
          <circle className={styles.st7} cx="455.9" cy="70" r="1.8" />
          <circle className={styles.st7} cx="468.9" cy="70" r="1.8" />
          <circle className={styles.st23} cx="477.5" cy="74.3" r="0.8" />
          <circle className={styles.st23} cx="447.7" cy="74.3" r="0.8" />
          <path className={styles.st24}
            d="M445.1,56.3c0.3-3.6,7.5-6.8,16.1-6.1c8.5,0.7,15.1,5.2,14.8,8.8c-0.3,3.6-7.5,5.9-16,5.2C451.5,63.5,444.8,60,445.1,56.3z"
          />
          <path className={styles.st14} d="M461.4,73.4c1.1-0.3,2.2,0.2,2.5,1.1c0.2,0.9-0.5,1.9-1.6,2.2" />
        </g>
        <g>
          <line className={styles.st29} x1="304.9" y1="9.3" x2="304.9" y2="13.3" />
          <line className={styles.st29} x1="343.1" y1="9.3" x2="343.1" y2="13.3" />
        </g>
        <g>
          <line className={styles.st29} x1="78.7" y1="149.5" x2="78.7" y2="153.5" />
          <line className={styles.st29} x1="116.9" y1="149.5" x2="116.9" y2="153.5" />
        </g>
        <g>
          <line className={styles.st29} x1="532.5" y1="149.5" x2="532.5" y2="153.5" />
          <line className={styles.st29} x1="570.7" y1="149.5" x2="570.7" y2="153.5" />
        </g>
        <line className={styles.st30} x1="204.1" y1="118.4" x2="262.7" y2="235" />
        <line className={styles.st30} x1="81.3" y1="303.7" x2="135.9" y2="302.4" />
        <line className={styles.st30} x1="566.5" y1="303.7" x2="515.4" y2="302.5" />
        <line className={styles.st30} x1="449.2" y1="118.4" x2="390.6" y2="235" />
        <g>
          <g>
            <path className={styles.st31}
              d="M226.8,143.2c-10.6,0-19.3,8.7-19.3,19.3s8.7,19.3,19.3,19.3c10.6,0,19.3-8.7,19.3-19.3S237.4,143.2,226.8,143.2z"
            />
          </g>
          <circle className={styles.st32} cx="226.8" cy="158.8" r="17.8" />
          <g>
            <path className={styles.st33} d="M239.1,157.4v8.6c0,1.2-1,2.2-2.3,2.2h-20.2c-1.2,0-2.2-1-2.2-2.2v-8.6H239.1z" />
            <path className={styles.st33} d="M239.1,152.4v5.1h-24.7v-5.1c0-1.2,1-2.2,2.2-2.2h20.2C238.1,150.1,239.1,151.1,239.1,152.4z" />
            <path className={styles.st33} d="M227.5,161.2h-1.3c-0.4,0-0.8-0.4-0.8-0.8v-2.5h2.9v2.5C228.2,160.9,227.9,161.2,227.5,161.2z" />
            <path className={styles.st33} d="M232.4,150.1v-1.8c0-0.5-0.3-0.9-0.7-0.9h-9.9c-0.4,0-0.7,0.4-0.7,0.9v1.8H232.4z" />
            <g>
              <line className={styles.st34} x1="219.5" y1="157.4" x2="219.5" y2="168.2" />
              <line className={styles.st34} x1="234.1" y1="157.4" x2="234.1" y2="168.2" />
            </g>
          </g>
        </g>
        <g>
          <g>
            <path className={styles.st31} d="M539.2,293.4c-6.1,0-11,4.9-11,11s4.9,11,11,11c6.1,0,11-4.9,11-11S545.3,293.4,539.2,293.4z" />
          </g>
          <circle className={styles.st32} cx="539.2" cy="302.3" r="10.1" />
          <g>
            <path className={styles.st35} d="M544.9,302v4c0,0.6-0.5,1-1,1h-9.4c-0.6,0-1-0.5-1-1v-4H544.9z" />
            <path className={styles.st35} d="M544.9,299.7v2.4h-11.5v-2.4c0-0.6,0.5-1,1-1h9.4C544.5,298.6,544.9,299.1,544.9,299.7z" />
            <path className={styles.st35} d="M539.2,303.8L539.2,303.8c-0.4,0-0.7-0.3-0.7-0.7v-0.9h1.4v0.9C539.9,303.5,539.6,303.8,539.2,303.8z" />
            <path className={styles.st35} d="M541.8,298.6v-0.9c0-0.2-0.1-0.4-0.3-0.4h-4.6c-0.2,0-0.3,0.2-0.3,0.4v0.9H541.8z" />
            <g>
              <line className={styles.st36} x1="535.8" y1="302" x2="535.8" y2="307.1" />
              <line className={styles.st36} x1="542.6" y1="302" x2="542.6" y2="307.1" />
            </g>
          </g>
        </g>
        <g>
          <g>
            <path className={styles.st31} d="M108.6,294c-6.1,0-11,4.9-11,11s4.9,11,11,11c6.1,0,11-4.9,11-11S114.6,294,108.6,294z" />
          </g>
          <circle className={styles.st32} cx="108.6" cy="302.9" r="10.1" />
          <g>
            <path className={styles.st35} d="M114.3,302.6v4c0,0.6-0.5,1-1,1h-9.4c-0.6,0-1-0.5-1-1v-4H114.3z" />
            <path className={styles.st35} d="M114.3,300.3v2.4h-11.5v-2.4c0-0.6,0.5-1,1-1h9.4C113.8,299.3,114.3,299.7,114.3,300.3z" />
            <path className={styles.st35} d="M108.6,304.4L108.6,304.4c-0.4,0-0.7-0.3-0.7-0.7v-0.9h1.4v0.9C109.3,304.1,109,304.4,108.6,304.4z" />
            <path className={styles.st35} d="M111.2,299.3v-0.9c0-0.2-0.1-0.4-0.3-0.4h-4.6c-0.2,0-0.3,0.2-0.3,0.4v0.9H111.2z" />
            <g>
              <line className={styles.st36} x1="105.2" y1="302.6" x2="105.2" y2="307.7" />
              <line className={styles.st36} x1="112" y1="302.6" x2="112" y2="307.7" />
            </g>
          </g>
        </g>
        <g>
          <g>
            <path className={styles.st31} d="M417.9,163.5c-10.6,0-19.3,8.7-19.3,19.3s8.7,19.3,19.3,19.3s19.3-8.7,19.3-19.3S428.5,163.5,417.9,163.5z" />
          </g>
          <circle className={styles.st37} cx="417.9" cy="179.2" r="17.8" />
          <g>
            <path className={styles.st38}
              d="M417.5,167.3l-12.2,8.2c-0.7,0.6-0.3,1.8,0.7,1.8h2.2c0.6,0,1,0.5,1,1v10.4c0,0.6,0.5,1,1,1h15.9c0.6,0,1-0.5,1-1v-10.4c0-0.6,0.5-1,1-1h2.2c1,0,1.4-1.2,0.7-1.8l-12.2-8.2C418.4,167,417.9,167,417.5,167.3z"
            />
            <polyline className={styles.st38} points="421,189.8 421,179.7 415.3,179.7 415.3,189.8" />
            <circle className={styles.st39} cx="418.1" cy="174" r="2.2" />
          </g>
        </g>
        </svg>
      </div>
    );
  }
}

ClockinCycle.propTypes = {
  className: PropTypes.string,
};

export default ClockinCycle;



// WEBPACK FOOTER //
// ./src/components/sign_up/sign_up_carousel/shared/clockin_cycle/index.jsx